import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import translateString from '../../utils/Locales';
import { NineCellLoading } from 'react-loadingg';
import getClient from '../../services/getClient';
import Cookies from 'universal-cookie';
import '../landingPage/style.css';
import moment from 'moment';
import './style.css';

let t = translateString;

export default class ManageAccount extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        
        const cookies = new Cookies();
        const db = cookies.get('db', { path: '/' });
        let cliente = await getClient('', '', db);
        var rem = undefined;

        if (cliente != null) {
            if (cliente.is_expirable === '1') {
                const startDate = moment(cliente.startDate, "DD/MM/yyyy");
                const endDate = startDate.add(30, 'days');
                const today = moment().startOf('day');
                console.log(cliente.is_expirable);
                rem = moment.duration(endDate.diff(today)).asDays();
                console.log(rem);
            }
            this.setState({ isLoading: false, cliente: cliente, daysLeft: rem });
        }
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;
        return(
            <>
                <PageTitle title={t('gestione_account')} />
                { this.state.cliente.type === '1' && (
                <div>
                    <div style={{ ...mainView }}>
                    <h4 style={{ fontWeight: 'bold' }}>{t('tuo_account')} <span style={{ color: '#B1D36A' }}>DEMO</span></h4>
                            {this.state.daysLeft !== undefined && (<h6 style={{ fontWeight: 'bold', color: '#828282' }}>{t('giorni_restanti')} {this.state.daysLeft}</h6>)}
                    <section style={{ marginTop: '30px', marginLeft: '20px' }}>
                        
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                            <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_1')}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                            <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                            <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('free_3')}</span>
                        </div>
                        {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                            <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                            <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('free_4')}</span>
                        </div> */}
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                            <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                            <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_2')}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={require('../../images/cancel-1.png') } />
                            <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_1')}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                            <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/cancel-1.png') } />
                            <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_2')}</span>
                        </div>
                    </section>
                </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <div style={{ ...mainView, marginTop: '30px', width: '45%' }}>
                            <h4 style={{ fontWeight: 'bold' }}>{t('passa_account')} <span style={{ color: 'orange' }}>CUSTOM</span></h4>
                            <h6 style={{ fontWeight: 'bold', color: '#828282' }}>{t('chiedi_preventivo')}</h6>
                            <section style={{ marginTop: '30px', marginLeft: '20px' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_4')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_1')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_2')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_3')}</span>
                                </div>
                            </section>
                            <section style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 25 }}>
                                <div className="btn btn-primary" onClick={() => window.location.href = "mailto:info@appius.it?subject=Custom plan information for " + new Cookies().get('db', { path: '/' }) } style={{marginTop: 8}}>{t('chiedi_informazioni')}</div>
                            </section>
                        </div>
                        <div style={{marginTop: '30px', width: '45%', position:'relative', overflow:'hidden',marginLeft:'5%'}} >
                            <div id='img_bg'>
                                <img id='icon_bg' src={require('../../images/icon.png')} alt=''></img>
                            </div>
                        </div>
                    </div>
                </div>
                )}
                { /*this.state.cliente.type === '1' && (
                    <div style={{ ...mainView }}>
                        <h4 style={{ fontWeight: 'bold' }}>{t('tuo_account')} <span style={{ color: 'orange' }}>CUSTOM</span></h4>
                        <section style={{ marginTop: '30px', marginLeft: '20px' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_4')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_1')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_2')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                    <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                    <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_3')}</span>
                                </div>
                            </section>
                            <section style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 20, marginLeft: '20px' }}>
                                <div className="btn btn-primary" onClick={() => window.location.href = "mailto:info@appius.it" } style={{marginTop: 8}}>{t('contattaci')}</div>
                            </section>
                    </div>
                )*/}
            </>
        );
    }
}

const mainView = {
    backgroundColor: 'white', 
    borderRadius: '10px', 
    padding: '30px',
    boxShadow: '0px 2px 10px lightgrey', 
    width: '95%',
}